module.exports = __webpack_public_path__ + "static/media/sales.214841a4.svg";